import React, { useState, useContext } from 'react';
import { Badge, Box, AppBar, Popover, Toolbar, Typography, IconButton } from '@mui/material';
import AppleIcon from '@mui/icons-material/Apple';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Context} from '../../store/Context';

function Header({ 
    reset, 
    checkout 
}) {        

    const { contextState: { storeName, totalItems} } = useContext( Context );
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => setAnchorEl(event.currentTarget)
    const handleClose = () => setAnchorEl(null)
    const open = Boolean(anchorEl);
    const id = open ? 'id-order-amount' : undefined;

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar variant="dense" sx={{ justifyContent: "space-between" }}>  
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                    }}>                 
                        <IconButton
                            size="large"
                            aria-label="Apple Logo"
                            color="inherit"                    
                        >
                             <AppleIcon />  
                        </IconButton>
                        <Typography variant="h6" color="inherit" component="div">
                            {storeName}
                        </Typography>                          
                    </Box>
                    <Box>                        
                        <IconButton
                            size="large"
                            aria-label={`Products in basket: ${totalItems}`}
                            color="inherit"
                            aria-describedby={id} 
                            onClick={handleClick}
                        >
                            <Badge badgeContent={totalItems} color="success">
                                <ShoppingBasketIcon />
                            </Badge>
                        </IconButton>
                        <Popover
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                        >
                            <Typography sx={{ p: 2 }}>Items: {totalItems}</Typography>
                        </Popover>     
                         <IconButton
                            size="large"
                            aria-label={`Products in basket: ${totalItems}`}
                            color="inherit"
                            aria-describedby={id} 
                            onClick={reset}
                        >                          
                            <HighlightOffIcon />                            
                        </IconButton>
                        {/*<PopupState variant="popover" popupId="store-menu">
                            {(popupState) => (
                                <React.Fragment>
                                    <Button variant="contained" {...bindTrigger(popupState)}>
                                        Actions
                                    </Button>                
                                    <Menu {...bindMenu(popupState)}>
                                        <MenuItem onClick={() => resetStore(popupState)}>Reset Store</MenuItem>                                
                                    </Menu>
                                </React.Fragment>                            
                            )}
                        </PopupState>   
                        */}
                         <IconButton
                            size="large"
                            aria-label={`Products in basket: ${totalItems}`}
                            color="inherit"
                            aria-describedby={id} 
                            onClick={checkout}
                        >
                            <ShoppingCartCheckoutIcon />
                        </IconButton>            
                    </Box>
                </Toolbar>
            </AppBar>
        </Box>
      );
}
 

export default Header;

/*
 <Button variant="contained" {...bindTrigger(popupState)}>
                        Dashboard
                      </Button>


*/